import { APP_INITIALIZER, Injectable, Provider } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { TranslateLoader, TranslateService } from '@ngx-translate/core';

const DEFAULT_RIDE_WSS_LANGUAGE = 'en';
const RIDE_WSS_I18N_PREFIX = '/assets/ride-wss-app/i18n/';

@Injectable()
export class RideWssTranslateLoader implements TranslateLoader {
  constructor(private readonly http: HttpClient) {}

  getTranslation(lang: string): Observable<Record<string, unknown>> {
    return this.http.get<Record<string, unknown>>(`${RIDE_WSS_I18N_PREFIX}${lang}.json`);
  }
}

function initializeRideWssTranslations(translateService: TranslateService) {
  return () => {
    translateService.setDefaultLang(DEFAULT_RIDE_WSS_LANGUAGE);
    return firstValueFrom(translateService.use(DEFAULT_RIDE_WSS_LANGUAGE));
  };
}

export function provideRideWssTranslateInitializer(): Provider {
  return {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: initializeRideWssTranslations,
    deps: [TranslateService]
  };
}
